import { Controller } from "stimulus"

export default class extends Controller {
  show(event) {
    // Prevent the default link behavior to avoid Turbo frame fetch
    event.preventDefault()
    // Dispatch event to show the onboarding modal
    document.dispatchEvent(new CustomEvent("onboarding:show"))
  }
}
